module.exports = __webpack_public_path__ + "static/media/com03.16480978.jpg";